const debounce = (callback: (...args: any[]) => void, delay = 0) => {
  let timerId: any = null;
  return (...args: any[]) => {
    timerId && clearTimeout(timerId);
    timerId = setTimeout(() => callback(...args), delay);
  };
};

export default debounce;
